import { PublicKey } from "@solana/web3.js";

export const UXD_STAKING_CAMPAIGN_PDA = new PublicKey("GMkG1Xr1ZAtLbHRxfbqLFEHqjP7rGwEfhQFed41aEL1k");

export const UXD_STAKING_PROGRAM_ID = new PublicKey("UXDSkps5NR8Lu1HB5uPLFfuB34hZ6DCk7RhYZZtGzbF");

export const UXP_MINT = new PublicKey("UXPhBoR3qG4UCiGNJfV7MqhHyFqKN68g45GoYvAeL2M");
